import { API_BASE } from './apiEndpoints';

export { API_BASE };

export const DEFAULT_AVATAR = '/default-avatar.svg';

const LEGACY_DEFAULT_AVATARS = new Set(['/default-avatar.png', '/default-avatar.svg']);

export function isDefaultAvatar(avatar: string | null | undefined): boolean {
  if (!avatar) return true;
  return LEGACY_DEFAULT_AVATARS.has(avatar);
}

/** URL для отображения аватара: /uploads/... -> API_BASE + path, иначе avatar или дефолт */
export function getAvatarSrc(avatar: string | null | undefined): string {
  if (isDefaultAvatar(avatar)) return DEFAULT_AVATAR;
  if (avatar.startsWith('/uploads/')) return API_BASE + avatar;
  return avatar;
}
